// Official GoCaptcha output, generated offline for the browser-only demo.
// Answers are intentionally bundled in this mock; never use it as a real verifier.
// See docs/login-slider-verification.md for generation and upstream licenses.
export async function createSlideFixture() {
  const { default: fixtures } = await import('./generated/slide-fixtures.json');
  const fixture = fixtures[Math.floor(Math.random() * fixtures.length)];
  return { answer: { ...fixture.answer }, data: { ...fixture.data } };
}
